/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.hero_main", {
        options: {
            textSliderOptions: {
                arrows: false,
                autoplay: true,
                autoplaySpeed: 6000,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: false,
                dots: true,
                rows: 0,
                pauseOnFocus: false,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            fade: true,
                        },
                    },
                ],
            },
            imgSliderOptions: {
                arrows: false,
                autoplay: true,
                autoplaySpeed: 8000,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: false,
                dots: false,
                rows: 0,
                pauseOnFocus: false,
                pauseOnHover: false,
            },
        },

        _create: function () {
            this.wrap = this.element;

            this.$textSlider = $(".s-hero-main__body", this.wrap);
            this.$imgSlider = $(".s-hero-main__media", this.wrap);

            if (this.$textSlider.length && this.$imgSlider.length) {
                const imgOptions = {
                    ...this.options.imgSliderOptions,
                    asNavFor: this.$textSlider,
                };

                const textOptions = {
                    ...this.options.textSliderOptions,
                    asNavFor: this.$imgSlider,
                };

                this.$imgSlider.slick(imgOptions);

                this.$textSlider
                    .on("init", (slick) => {
                        var dots = $(".slick-dots", $(slick.target));
                        api.fn.slickDotsInit(dots, this.options.textSliderOptions.autoplaySpeed / 1000);
                    })
                    .slick(textOptions)
                    .on("beforeChange", (event, slick, currentSlide, nextSlide) => {
                        var dots = $(".slick-dots", $(event.target));
                        api.fn.slickDotsFilled(dots, nextSlide);
                    });
            }
        },
    });
})(jQuery);
